import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";

let nextSelectorId = 0;

@Component({
  selector: "app-cmn-selector",
  templateUrl: "./cmn-selector.component.html",
  styleUrls: ["./cmn-selector.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmnSelectorComponent {
  readonly inputId = `cmn-selector-${nextSelectorId++}`;

  @Input() checked = false;
  @Input() label = "";
  @Input() description = "";
  @Input() ariaLabel = "";
  @Input() featured = false;
  @Input() type: "checkbox" | "radio" = "checkbox";
  @Output() toggled = new EventEmitter<void>();

  onChange(event: Event): void {
    event.stopPropagation();
    this.toggled.emit();
  }

  get labelForAssistiveText(): string {
    return this.ariaLabel || this.label || "Toggle choice";
  }
}
